import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [accessToken, setAccessToken] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      // Get tokens from sessionStorage (set by AuthSuccess)
      const token = sessionStorage.getItem('access_token');
      
      if (!token) {
        // If no token found, redirect to login
        navigate('/login');
        return;
      }

      setAccessToken(token);

      // Optional: Decode ID token to get user info
      try {
        const idToken = sessionStorage.getItem('id_token');
        if (idToken) {
          const payload = JSON.parse(atob(idToken.split('.')[1]));
          setUserInfo({
            name: payload.name || payload.preferred_username,
            email: payload.email
          });
        }
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogout = () => {
    // Clear tokens and redirect
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('id_token');
    navigate('/');
  };

  return (
    <div className="dashboard-container">
      <h1>Welcome to Dashboard</h1>
      
      {userInfo && (
        <div className="user-profile">
          <h2>User Information</h2>
          <p>Name: {userInfo.name}</p>
          <p>Email: {userInfo.email}</p>
        </div>
      )}

      <div className="token-info">
        <h2>Session Status</h2>
        <p>You are successfully authenticated</p>
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default Dashboard;